<select (change)="setValue(dropdownSelect.value)" class="form-select" [id]="id" #dropdownSelect>
	<option id="placeholder" [ngValue]="undefined">{{placeholder | translate}}</option>
	<option id="item-{{i}}" *ngFor="let dropdownItem of providedData; let i = index" [value]="dropdownItem.value">{{ dropdownItem.label | translate}}</option>
</select>
